// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// Add and set domain imports here.
import { InjectionToken } from '@angular/core';
export const DOMAIN_CONFIG = new InjectionToken<any>('DOMAIN_CONFIG');
export function domainNameToFileName(hostname: string): string {
  return hostname
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .replace(/\/$/, '')
    .replace(/-website\..+$/, '')
    .replace(/\.[a-z]+$/, '')
    .replace(/[^a-z0-9]/gi, '');
}
 
function environmentPromise(ssrHostname?: string): Promise<any> {
  const domainName = typeof window !== 'undefined' ? window.location.hostname : (ssrHostname || '');
  return new Promise<any>((resolve) => {
    let domainConfig: any;
    (async () => {
      const isDevHost = domainName === 'localhost' || domainName === 'angular_dev';
      const fileName = isDevHost ? 'env' : domainNameToFileName(domainName);
      try {
        domainConfig = await import(`./${fileName}.json`);
      } catch {
        domainConfig = await import('./env.json');
      }
      setDomainConfig(domainConfig);
      resolve(environment);
    })();
  })
}
 
export function setDomainConfig(domainConfig) {
  environment.apiUrl = domainConfig.apiUrl;
  environment.imageBasePath = domainConfig.imageBasePath;
  environment.commonImagePath = domainConfig.commonImagePath;
  environment.domainImageBasePath = domainConfig.domainImageBasePath;
   environment.cutomerGalleryTitle = domainConfig.cutomerGalleryTitle;
  environment.storeImagePath = domainConfig.storeImagePath;
  environment.cdnImagePath = domainConfig.cdnImagePath;
  environment.websitecdn = domainConfig.websitecdn;
  environment.client_id = domainConfig.client_id;
  environment.csscdnPath = domainConfig.csscdnPath;
  environment.domainName = domainConfig.domainName;
  environment.themeName = domainConfig.themeName;
  environment.contact_no = domainConfig.contact_no;
  environment.blackSearch = domainConfig.blackSearch;
  environment.preicon = domainConfig.preicon;
  environment.nexticon = domainConfig.nexticon;
  environment.calendarIcon = domainConfig.calendarIcon;
  environment.catSubTitle = domainConfig.catSubTitle;
  environment.prodSubTitle = domainConfig.prodSubTitle;
  environment.catTitle = domainConfig.catTitle;
  environment.prodTitle = domainConfig.prodTitle;
  environment.brandTitle = domainConfig.brandTitle;
  environment.hobbyTitle = domainConfig.hobbyTitle;
  environment.brandSubTitle = domainConfig.brandSubTitle;
  environment.catButton = domainConfig.catButton;
  environment.chTheme1 = domainConfig.chTheme1;
  environment.chTheme2 = domainConfig.chTheme2;
  environment.chTheme3 = domainConfig.chTheme3;
  environment.chTheme4 = domainConfig.chTheme4;
  environment.chTheme5 = domainConfig.chTheme5;
  environment.chTheme6 = domainConfig.chTheme6;
  environment.chTheme7 = domainConfig.chTheme7;
  environment.chTheme8 = domainConfig.chTheme8;
  environment.chTheme9 = domainConfig.chTheme9;
  environment.chTheme10 = domainConfig.chTheme10;
  environment.chTheme11 = domainConfig.chTheme11;
  environment.chTheme12 = domainConfig.chTheme12;
  environment.chTheme13 = domainConfig.chTheme13;
  environment.chTheme14 = domainConfig.chTheme14;
  environment.chTheme15 = domainConfig.chTheme15;
  environment.chTheme16 = domainConfig.chTheme16;
  environment.phoneImg = domainConfig.phoneImg;
  environment.subArrow = domainConfig.subArrow;
  environment.subscribeButtonArrow = domainConfig.subscribeButtonArrow;
  environment.phoneImg = domainConfig.phoneImg;
  environment.closeIcon = domainConfig.closeIcon;
  environment.sidebar_top_seller_cat = domainConfig.sidebar_top_seller_cat;
  environment.sidebar_brand_btn = domainConfig.sidebar_brand_btn;
  environment.sidebar_promo_btn = domainConfig.sidebar_promo_btn;
  environment.dealsTitle = domainConfig.dealsTitle;
  environment.promo_btn = domainConfig.promo_btn;
  environment.placeholder_title = domainConfig.placeholder_title;
  environment.placeholder_subscribe = domainConfig.placeholder_subscribe;
  environment.shop_by_vehicle_name = domainConfig.shop_by_vehicle_name;
  environment.featuredCategoriesTitle = domainConfig.featuredCategoriesTitle;
  environment.partsSectionButton = domainConfig.partsSectionButton;
  environment.mob_calendarIcon = domainConfig.mob_calendarIcon;
  environment.top_sellar_btn = domainConfig.top_sellar_btn;
  environment.dealerHeading = domainConfig.dealerHeading;
  environment.viewAllServiceBtn = domainConfig.viewAllServiceBtn;
  environment.merchantProductUrl = domainConfig.merchantProductUrl;
  environment.showSocialMediaOnLogin = domainConfig.showSocialMediaOnLogin;
  environment.conatct_Comment = domainConfig.conatct_Comment;
  environment.contact_us_Name_Email_Commit = domainConfig.contact_us_Name_Email_Commit;
  environment.vehiclePopup = domainConfig.vehiclePopup;
}

export const environment = {
  production: false,
  showSocialMediaOnLogin: false,
  cutomerGalleryTitle:'',
  conatct_Comment:'',
  contact_us_Name_Email_Commit:false,
  vehiclePopup: {onSlider: false,underSlider: false},
  apiUrl: '',
  domainName: '',
  merchantProductUrl: '',
  themeName: '',
  //image base path
  imageBasePath: '',
  placeholder_subscribe:'',
  commonImagePath: '',
  domainImageBasePath: '',
  subscribeButtonArrow: '',
  storeImagePath: '',
  cdnImagePath: '',
  websitecdn: '',
  //Social Media keys
  client_id: '',
  csscdnPath: '',
  blackSearch: '',
  preicon: '',
  nexticon: '',
  calendarIcon: '',
  catTitle: '',
  viewAllServiceBtn:'',
  prodTitle: '',
  hobbyTitle: '',
  brandTitle: '',
  prodSubTitle:'',
  catSubTitle:'',
  brandSubTitle:'',
  catButton: '',
  phoneImg: '',
  contact_no: '',
  subArrow: '',
  dealsTitle: '',
  promo_btn: '',
  shop_by_vehicle_name: '',
  featuredCategoriesTitle: '',
  partsSectionButton: '',
  chTheme1: false,
  chTheme2: false,
  chTheme3: false,
  chTheme4: false,
  chTheme5: false,
  chTheme6: false,
  chTheme7: false,
  chTheme8: false,
  chTheme9: false,
  chTheme10: false,
  chTheme11: false,
  chTheme12: false,
  chTheme13: false,
  chTheme14: false,
  chTheme15: false,
  chTheme16: false, 
  closeIcon: '',
  mob_calendarIcon: '',
  sidebar_top_seller_cat: false,
  sidebar_brand_btn: false,
  sidebar_promo_btn: false,
  placeholder_title: '',
  top_sellar_btn: '',
  dealerHeading: '',
  errorMessage: 'Unable to process your request at this moment. Please try again after some time. If issue still presist, then please contact to our 24x7 support team.'
};
 
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
 
export { environmentPromise };
export const environmentAsync = environmentPromise();
 
export async function loadDomainConfig(hostname: string): Promise<any> {
  const isDevHost = hostname === 'localhost' || hostname === 'angular_dev';
  const fileName = isDevHost ? 'env' : domainNameToFileName(hostname);
  try {
    return await import(`./${fileName}.json`);
  } catch {
    return await import('./env.json');
  }
}
